import * as OpenCC from 'opencc-js'

// 创建简体 → 台湾繁体转换器（最通用，适用于台湾、香港、澳门、海外华人）
const converter = OpenCC.Converter({ from: 'cn', to: 'tw' })

// 判断是否为非大陆用户（只要不是明确 zh-CN 就转繁体）
function isNonMainlandUser() {
  const lang = (navigator.language || navigator.userLanguage || '').toLowerCase()
  return ['zh-hk', 'zh-tw'].includes(lang)
}

// 页面文本转换函数
export function convertPageToTraditional() {
  if (!isNonMainlandUser()) return

  function walk(node) {
    if (node.nodeType === 3) { // 文本节点
      const text = node.nodeValue.trim()
      if (text.length > 0) {
        node.nodeValue = converter(node.nodeValue)
      }
    } else if (node.nodeType === 1 &&
               !['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE'].includes(node.nodeName)) {
      node.childNodes.forEach(walk)
    }
  }

  walk(document.body)
}


// WEBPACK FOOTER //
// ./src/utils/opencc.js